function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { decodePacket } from "engine.io-parser";
import { Emitter } from "@socket.io/component-emitter";
import { installTimerFunctions } from "./util.js";
import { encode } from "./contrib/parseqs.js";
export var TransportError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(TransportError, Error1);
    function TransportError(reason, description, context) {
        _class_call_check(this, TransportError);
        var _this;
        _this = _call_super(this, TransportError, [
            reason
        ]);
        _this.description = description;
        _this.context = context;
        _this.type = "TransportError";
        return _this;
    }
    return TransportError;
}(_wrap_native_super(Error));
export var Transport = /*#__PURE__*/ function(Emitter) {
    "use strict";
    _inherits(Transport, Emitter);
    function Transport(opts) {
        _class_call_check(this, Transport);
        var _this;
        _this = _call_super(this, Transport);
        _this.writable = false;
        installTimerFunctions(_this, opts);
        _this.opts = opts;
        _this.query = opts.query;
        _this.socket = opts.socket;
        _this.supportsBinary = !opts.forceBase64;
        return _this;
    }
    _create_class(Transport, [
        {
            /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ key: "onError",
            value: function onError(reason, description, context) {
                _get(_get_prototype_of(Transport.prototype), "emitReserved", this).call(this, "error", new TransportError(reason, description, context));
                return this;
            }
        },
        {
            /**
     * Opens the transport.
     */ key: "open",
            value: function open() {
                this.readyState = "opening";
                this.doOpen();
                return this;
            }
        },
        {
            /**
     * Closes the transport.
     */ key: "close",
            value: function close() {
                if (this.readyState === "opening" || this.readyState === "open") {
                    this.doClose();
                    this.onClose();
                }
                return this;
            }
        },
        {
            /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ key: "send",
            value: function send(packets) {
                if (this.readyState === "open") {
                    this.write(packets);
                } else {
                // this might happen if the transport was silently closed in the beforeunload event handler
                }
            }
        },
        {
            /**
     * Called upon open
     *
     * @protected
     */ key: "onOpen",
            value: function onOpen() {
                this.readyState = "open";
                this.writable = true;
                _get(_get_prototype_of(Transport.prototype), "emitReserved", this).call(this, "open");
            }
        },
        {
            /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ key: "onData",
            value: function onData(data) {
                var packet = decodePacket(data, this.socket.binaryType);
                this.onPacket(packet);
            }
        },
        {
            /**
     * Called with a decoded packet.
     *
     * @protected
     */ key: "onPacket",
            value: function onPacket(packet) {
                _get(_get_prototype_of(Transport.prototype), "emitReserved", this).call(this, "packet", packet);
            }
        },
        {
            /**
     * Called upon close.
     *
     * @protected
     */ key: "onClose",
            value: function onClose(details) {
                this.readyState = "closed";
                _get(_get_prototype_of(Transport.prototype), "emitReserved", this).call(this, "close", details);
            }
        },
        {
            /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ key: "pause",
            value: function pause(onPause) {}
        },
        {
            key: "createUri",
            value: function createUri(schema) {
                var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
            }
        },
        {
            key: "_hostname",
            value: function _hostname() {
                var hostname = this.opts.hostname;
                return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
            }
        },
        {
            key: "_port",
            value: function _port() {
                if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) {
                    return ":" + this.opts.port;
                } else {
                    return "";
                }
            }
        },
        {
            key: "_query",
            value: function _query(query) {
                var encodedQuery = encode(query);
                return encodedQuery.length ? "?" + encodedQuery : "";
            }
        }
    ]);
    return Transport;
}(Emitter);
